import { inject, Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { IEvent } from './payment.busevents.service';
import { IIziPayRequestConfig, IIziPaymenGatewaytResponse } from '../classes/payment.interfaces';
import { IMakeTransferResponse } from './interfaces/izipai-make-transfer.interfaces';
import { environment } from 'environments/environment';
import { getTransactionIdUiid } from '../util/generate-data';
import { NewRelicService } from './newRelic.service';
import { request } from 'express';

@Injectable({
  providedIn: 'root'
})
export class MakeTransferService {

  private readonly http = inject(HttpClient);
  private newRelicService = inject(NewRelicService);

  public internalMakeAviTransfer(monitorData: any, event: IEvent): Observable<IMakeTransferResponse> {
    let ownership = true;
    let url = environment.bff_transger_avi_url; //"https://apiqa.digital.interbank.pe/external-payment-gateway/v1/avi-payments/transfer";

    const { paymentGateway, infoIzipay, infoBilling, ws_token } = event;
    this.newRelicService.addPageAction('SEND_DATA_TRANSFERS', {
      component: 'MakeTransferService',
      action: 'event',
      detail: 'paymentGateway: ' + paymentGateway?.code
        + ' infoIzipay: ' + infoIzipay?.customerId
        + ' infoBilling: ' + infoBilling?.email
        + ' ws_token: ' + ws_token,
      timestamp: new Date().toISOString()
    });

    const {
      response: {
        card,
        billing,
        dateTransaction,
        timeTransaction,
        codeAuth,
        uniqueId
      }
    } = paymentGateway as IIziPaymenGatewaytResponse;
    const { currency, amount, orderNumber, customerId, pan, access_token } = infoIzipay as IIziPayRequestConfig;

    url = url + '/' + ws_token;

    const transactionId = getTransactionIdUiid();
    this.newRelicService.addPageAction('SEND_DATA_TRANSFERS', {
      component: 'MakeTransferService',
      action: 'infoIzipay',
      detail: 'currency: ' + currency
        + ' amount: ' + amount
        + ' orderNumber: ' + orderNumber
        + ' customerId: ' + customerId,
      timestamp: new Date().toISOString()
    });

    const headers = new HttpHeaders({
      'X-Api-Force-Sync': 'true',
      'X-Correlation-Id': transactionId,
      'X-Transaction-Id': transactionId,
      'X-Api-Version': 'v1',
      'Ocp-Apim-Subscription-Key': environment.bff_token_avi_sub_key, //'87d8f7dac1be4a6b8ab51077325a0a0e',//'518e612caa394c918945e086c70acc46',
      'X-Origin-Id': 'WEB',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + access_token,
      'X-Monitor-Tracking-Device': this.getMonitorDeviceHeader(monitorData),
      'X-Monitor-Tracking-Data': this.getMonitorDataHeader(),
    });

    this.newRelicService.addPageAction('SEND_DATA_TRANSFERS', {
      component: 'MakeTransferService',
      action: 'headers',
      detail: 'X-Api-Force-Sync: ' + headers.get('X-Api-Force-Sync')
        + ' X-Correlation-Id: ' + headers.get('X-Correlation-Id')
        + ' X-Transaction-Id: ' + headers.get('X-Transaction-Id')
        + ' X-Api-Version: ' + headers.get('X-Api-Version')
        + ' X-Origin-Id: ' + headers.get('X-Origin-Id')
        + ' Content-Type: ' + headers.get('Content-Type'),
      timestamp: new Date().toISOString()
    });

    this.newRelicService.addPageAction('SEND_DATA_TRANSFERS', {
      component: 'MakeTransferService',
      action: 'headers-monitor',
      detail: 'X-Monitor-Tracking-Device: ' + headers.get('X-Monitor-Tracking-Device'),
      timestamp: new Date().toISOString()
    });

    this.newRelicService.addPageAction('SEND_DATA_TRANSFERS', {
      component: 'MakeTransferService',
      action: 'headers-monitor',
      detail: 'X-Monitor-Tracking-Data: ' + headers.get('X-Monitor-Tracking-Data'),
      timestamp: new Date().toISOString()
    });

    if (infoBilling) {
      billing.documentType = infoBilling.doc_type;
      billing.document = infoBilling.dni;
      billing.firstName = infoBilling.name;
      billing.lastName = infoBilling.lastname;
      billing.email = infoBilling.email;
      billing.phoneNumber = infoBilling.phone
      ownership = false;
    }

    // Define the request body
    const requestBody = {
      "destination": {
        "buyer": {
          "id": customerId,
        },
        "payCard": {
          "number": pan,
        }
      },
      "origin": {
        "payer": { //ingresar data de billing
          "identityDocument": {
            "type": billing.documentType,
            "number": billing.document
          },
          "firstName": billing.firstName,
          "lastName": billing.lastName,
          "address": [
            {
              "country": billing.country,
              "department": billing.state,
              "district": billing.city,
              "streetName": billing.street
            }
          ],
          "phone": [
            {
              "number": billing.phoneNumber
            }
          ],
          "emails": [
            {
              "value": billing.email
            }
          ]
        },
        "payCard": {
          "number": card.pan,
          "brand": 'DEBIT',
          "brandType": card.brand
        }
      },
      "currency": currency,
      "amount": amount,
      "orderNumber": orderNumber,
      "dateTransaction": dateTransaction,
      "timeTransaction": timeTransaction,
      "codeAuth": codeAuth,
      "ownership": ownership,
      "uniqueId": uniqueId
    };

    this.newRelicService.addPageAction('SEND_DATA_TRANSFERS', {
      component: 'MakeTransferService',
      action: 'requestBody',
      detail: 'identityDocumentType: ' + requestBody.origin?.payer?.identityDocument?.type
        + ' identityDocumentNumber: ' + requestBody.origin?.payer?.identityDocument?.number
        + ' amount: ' + requestBody.amount
        + ' currency: ' + requestBody.currency
        + ' orderNumber: ' + requestBody.orderNumber
        + ' ownership: ' + requestBody.ownership
        + ' url: ' + url,
      timestamp: new Date().toISOString()
    });
    return this.http.post<IMakeTransferResponse>(url, requestBody, { headers });
  }

  getMonitorDeviceHeader(monitorData: any): string {
    // Crear objeto por defecto si monitorData es null
    const safeMonitorData = monitorData || {
      Browser: {},
      General: {},
      Personalization: {},
      Alterations: {},
      Network: {},
      Site: {},
      Identifiers: {},
      GeoIp: {
        as: '',
        asname: '',
        callingCode: '',
        city: '',
        continent: '',
        continentCode: '',
        country: '',
        countryCode: '',
        countryCode3: '',
        currency: '',
        currentTime: '',
        district: '',
        hosting: false,
        isp: '',
        lat: 0,
        lon: 0,
        mobile: false,
        offset: 0,
        org: '',
        proxy: false,
        query: '192.168.0.1',
        region: '',
        regionName: '',
        reverse: '',
        status: '',
        timezone: '',
        zip: ''
      }
    };

    return btoa(JSON.stringify(safeMonitorData));
  }

  getMonitorDataHeader(): string {
    return btoa(
      JSON.stringify({
        originId: 'WEB-JS',
        securityLevel: '0P',
        sessionId: ''
      })
    );
  }
}